export const events = {
  add: {
    qualification: 'ADVISER_EDUCATION_ADD_NEW_QUALIFICATION'
  },
  edit: {
    start: 'ADVISER_EDUCATION_START_EDITING',
    stop: 'ADVISER_EDUCATION_STOP_EDITING',
    cancel: 'ADVISER_EDUCATION_CANCEL_EDITING'
  },
  set: {
    qualification: 'ADVISER_EDUCATION_SET_QUALIFICATION',
    startMonth: 'ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH',
    endMonth: 'ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH',
    startYear: 'ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR',
    endYear: 'ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR',
    endDateCurrent: 'ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT'
  },
  deletes: {
    modal: 'ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL',
    qualification: 'ADVISER_EDUCATION_DELETE_QUALIFICATION',
    cancel: 'ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION'
  }
}

const {add, edit, set, deletes} = events

export const actions = {
  add: {
    qualification: () => ({
      type: add.qualification,
      qualification: {
        description: null,
        institution: null,
        studyEndDate: new Date(),
        studyStartDate: new Date()
      }
    })
  },
  edit: {
    start: index => ({
      type: edit.start,
      index
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  set: {
    qualification: (validationResult, qualification) => ({
      type: set.qualification,
      qualification,
      validationResult
    }),
    startMonth: (validationResult, month) => ({
      type: set.startMonth,
      month,
      validationResult
    }),
    startYear: (validationResult, year) => ({
      type: set.startYear,
      validationResult,
      year
    }),
    endMonth: (validationResult, month) => ({
      type: set.endMonth,
      month,
      validationResult
    }),
    endYear: (validationResult, year) => ({
      type: set.endYear,
      validationResult,
      year
    }),
    endDateCurrent: () => ({
      type: set.endDateCurrent
    })
  },
  deletes: {
    modal: index => ({
      type: deletes.modal,
      index
    }),
    qualification: () => ({
      type: deletes.qualification
    }),
    cancel: () => ({
      type: deletes.cancel
    })
  }
}
